/**
 * ThemeContext.js
 * Provides the theme context to switch themes
 */
import { createContext } from "react";

// Create the context
const ThemeContext = createContext(null);
export default ThemeContext;

